/**
 * App layout
 */

// React
import React from 'react';

// Material
import { Container } from '@mui/material';

// Components
import Footer from 'components/Footer';
import Loading from 'components/Loading';
import SnackNotify from 'components/SnackNotify';
import Header from 'components/Header';
import NotifyComponent from 'components/Notify';

// Common styles
import { ContentLayout, LayoutContainer, PageContainer } from 'styles';

// Utils
import { CombinedRouteProps } from 'utils/types';

// Component
const AppLayout: React.FC<CombinedRouteProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  maxWidth,
  alignItems = 'start',
}) => {
  return (
    <LayoutContainer>
      {showHeader && <Header />}
      <ContentLayout
        sx={{
          alignItems: alignItems,
        }}
      >
        <Container
          maxWidth={maxWidth ? maxWidth : false}
          sx={{
            paddingX: maxWidth ? { xs: '20px', sm: '20px', md: '0px' } : '0px !important',
          }}
        >
          <SnackNotify />
          <Loading />
          <PageContainer>
            <NotifyComponent />
          </PageContainer>

          {children}
        </Container>
      </ContentLayout>
      {showFooter && <Footer />}
    </LayoutContainer>
  );
};

export default AppLayout;
